import { render, staticRenderFns } from "./vRecipeBreakdownTable.vue?vue&type=template&id=4d9ba077&scoped=true"
import script from "./vRecipeBreakdownTable.vue?vue&type=script&lang=ts"
export * from "./vRecipeBreakdownTable.vue?vue&type=script&lang=ts"
import style0 from "./vRecipeBreakdownTable.vue?vue&type=style&index=0&id=4d9ba077&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9ba077",
  null
  
)

export default component.exports